import { EmptyTreatmentConsultationList } from 'components/atoms';
import { TablePagination } from 'components/molecules';
import { useTreatmentConsultation } from 'context';
import React from 'react';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { TreatmentConsultationRow } from '../TreatmentConsultationRow';
import { ITreatmentConsultation, ITreatmentPrescription } from 'types';

export const TreatmentConsultationTable: React.FC = () => {
  const {
    docs,
    totalPages,
    hasSomeDoc,
    page,
    treatmentOnGoingId,
    saveTreatmentConsultationModal,
    handleNextPage,
    handlePreviousPage,
    handleChangeSelectedConsultation,
    handleChangeSelectedPrescription,
  } = useTreatmentConsultation();

  if (!hasSomeDoc) {
    return <EmptyTreatmentConsultationList />;
  }

  const handleSelected = (consultation: ITreatmentConsultation) => () => {
    handleChangeSelectedConsultation(consultation);
  };

  const handleSelectedPrescription =
    (prescription: ITreatmentPrescription | undefined) => () => {
      handleChangeSelectedPrescription(prescription);
    };

  return (
    <>
      <TableContainer sx={{ mt: 4 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Data</TableCell>
              <TableCell>Tipo de Consulta</TableCell>
              <TableCell>Veterinário</TableCell>
              <TableCell align="center" width={50}>
                Ação
              </TableCell>
            </TableRow>
          </TableHead>

          {!docs?.length && (
            <Typography component="caption">
              <Box textAlign="center">
                Esse pet não possui nenhum registro para essa data.
              </Box>
            </Typography>
          )}

          <TableBody>
            {docs?.map((consultation) => (
              <TreatmentConsultationRow
                key={consultation.id}
                consultation={consultation}
                editable={consultation.treatmentId === treatmentOnGoingId}
                onEditClick={saveTreatmentConsultationModal.onOpen}
                onViewConsultationClick={handleSelected(consultation)}
                onViewPrescriptionClick={handleSelectedPrescription(
                  consultation?.prescription
                )}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        currentPage={page}
        maxPage={totalPages}
        onNextClick={handleNextPage}
        onPreviousClick={handlePreviousPage}
      />
    </>
  );
};
